import { styled } from '@nykaa/ui-components';
import { HIDE_SCROLLBARS, HORIZONTAL_SCROLLBARS, BREAKPOINTS } from 'shared/styles/base';

export const Container = styled.div`
  display: flex;
  width: 100%;
  overflow-x: auto;

  @media screen and (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${HIDE_SCROLLBARS}
  }

  @media screen and (min-width: ${BREAKPOINTS.DESKTOP}px) {
    padding-bottom: ${({ theme }) => theme.spacing.spacing40};
    ${HORIZONTAL_SCROLLBARS}
  }
`;
